import { type EntityId, makeEntityId } from '@web-platform/shared-universal-types-utils/src/utils';

import type Suggestion from './autoSuggest/index';
import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

export function suggestionToSearchPlace(suggestion: Suggestion): SearchLegPlace {
  return {
    id: suggestion.PlaceId || '',
    name: suggestion.PlaceName,
    cityId: suggestion.CityId || '',
    cityName: suggestion.CityName || '',
    countryId: suggestion.CountryId || '',
    // Empty EntityIds preserve the legacy autosuggest fallback shape, but this pattern is not encouraged.
    // Prefer either nullable fields or real EntityIds when these fallbacks are revisited.
    geoId: suggestion.GeoId || makeEntityId(''),
    geoContainerId: suggestion.GeoContainerId || makeEntityId(''),
    type: suggestion.getType(),
    // AutoSuggest suggestions will always have the GeneralSuggestion object, but hand created EverywhereSuggestions do not
    // FIXME: SHIBA-809 Bad typecasting - do not copy this pattern
    travelEntityId: suggestion.GeneralSuggestion ? (suggestion.GeoContainerId as EntityId) : null,
  };
}
